// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_65-0";
export var eligibilityCardNotEligible = "_65-1";